/**************************************************************************
 * Created on Tue Feb 11 2026
 *
 *  # Honeywell Code Usage Policy
 *
 * **Honeywell Source Code Usage Policy Classification:** Highly Confidential
 *
 * [comment]: # (Options for above are "Inner Source", "General Application", "Highly Confidential", "Export Controlled")
 *
 * **This repository has multiple classifications:** Yes
 *
 * [comment]: # (Options for above are "Yes" when subfolders contain a separate policy,"No" when the whole repo has the same policy)
 *
 * **Honeywell confidential - For internal use only.
 *
 * Property of and copyright ownership by Honeywell International Inc. and/or its affiliates.
 *
 * Use of source code must follow all Honeywell policies including the [HCE Source Code Access Policy](http://go.honeywell.com/hce-code-access-policy).
 *
 * External use or distribution prohibited without written approval per Honeywell policies**
 *
********************************************************************************/

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SideBarMenuItem, ISidebarMenuItem, onActiveLink } from '../sidebar-menu-item/SideBarMenuItem';

import { ReactComponent as OverviewIcon } from "../../assets/Overview.svg";
import { ReactComponent as DownloadIcon } from "../../assets/Download.svg";

import { ReactComponent as Support } from "../../assets/News-Updates.svg";
type Props = {
  active: string;
  onMenuClick: () => void;
  openSubMenu: string | null;
  setOpenSubMenu: (key: string | null) => void;
  ['data-testid']?: string;
  menuPosition: any;
  leftmenu: boolean;
};

const SideBarGuest: React.FC<Props> = (props) => {
  const nav = useNavigate();
  const location = useLocation();
  const basePath = '/guest';
  const [activeMenu, setActiveMenu] = React.useState<string | null>(null);

  const menuItems: ISidebarMenuItem[] = [
    {
      title: 'Overview',
      hasIcon: true,
      iconAssetPath: OverviewIcon,
      leftmenu: props.leftmenu,
      active: activeMenu === "Overview" ? "active" : "",
      onClick: () => {
        nav(`${basePath}/overview`);
        setActiveMenu("Overview");
      },
    },
    {
      title: 'Support',
      hasIcon: true,
      iconAssetPath: Support,
      leftmenu: props.leftmenu,
      active: activeMenu === "Support" ? "active" : "",
      onClick: () => { setActiveMenu("Support"); },
      subMenus: [
        {
          title: "Products and Services",
          leftmenu: props.leftmenu,
          className: onActiveLink(location.pathname.toString().indexOf("product") > -1),
          onClick: () => nav(`${basePath}/support/product`),
        } as ISidebarMenuItem,
        {
          title: 'Customer Support',
          leftmenu: props.leftmenu,
          active: onActiveLink(location.pathname.indexOf(`${basePath}/support/customerSupport`) > -1),
          onClick: () => nav(`${basePath}/support/customerSupport`),
        },
        {
          title: 'Online Help',
          leftmenu: props.leftmenu,
          active: onActiveLink(location.pathname.indexOf(`${basePath}/support/onlineHelp`) > -1),
          onClick: () => nav(`${basePath}/support/onlineHelp`),
        },
        {
          title: 'Quality Documents',
          leftmenu: props.leftmenu,
          active: onActiveLink(location.pathname.indexOf(`${basePath}/support/qualityDocuments`) > -1),
          onClick: () => nav(`${basePath}/support/qualityDocuments`),
        },
        {
          title: 'Tools & Tech Info',
          leftmenu: props.leftmenu,
          active: onActiveLink(location.pathname.indexOf(`${basePath}/support/toolsInfo`) > -1),
          onClick: () => nav(`${basePath}/support/toolsInfo`),
        },
        {
          title: 'News & Events',
          leftmenu: props.leftmenu,
          active: onActiveLink(location.pathname.indexOf(`${basePath}/support/newsEvents`) > -1),
          onClick: () => nav(`${basePath}/support/newsEvents`),
        },
      ],
    },
    {
      title: 'Flight Info',
      hasIcon: true,
      iconAssetPath: Support,
      leftmenu: props.leftmenu,
      active: activeMenu === "Flight Info" ? "active" : "",
      onClick: () => { setActiveMenu("Flight Info"); },
      subMenus: [
        {
          title: "Alerts/Notices",
          leftmenu: props.leftmenu,
          className: onActiveLink(location.pathname.toString().indexOf("alerts-and-notices") > -1),
          onClick: () => nav(`${basePath}/flight-info/alerts-and-notices`),
        } as ISidebarMenuItem,
        {
          title: "DataBase/MediaType",
          leftmenu: props.leftmenu,
          className: onActiveLink(location.pathname.toString().indexOf("/database-mediatype") > -1),
          onClick: () => nav(`${basePath}/flight-info/database-mediatype`),
        } as ISidebarMenuItem,
        {
          title: "EGPWS Terr DB Search",
          leftmenu: props.leftmenu,
          className: onActiveLink(location.pathname.toString().indexOf("egpws-search") > -1),
          onClick: () => nav(`${basePath}/flight-info/egpws-search`),
        } as ISidebarMenuItem,
      ],
    },
    {
      title: 'Databases',
      hasIcon: true,
      iconAssetPath: DownloadIcon,
      leftmenu: props.leftmenu,
      active: onActiveLink(location.pathname.toString().indexOf(`${basePath}/database`) > -1),
      onClick: () => nav(`${basePath}/database/guest-download`),
    },
  ];

  return (
    <div data-testid={props['data-testid']}>
      {menuItems.map((item, index) => (
        <SideBarMenuItem
          key={index}
          {...item}
          openSubMenu={props.openSubMenu}
          setOpenSubMenu={props.setOpenSubMenu}
          menuKey={item.title}
        />
      ))}
    </div>
  );
};

export default SideBarGuest;
